import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { navigate("/login", { replace: true }); return; }

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        if (r.data.session_token) localStorage.setItem("session_token", r.data.session_token);
        setUser(r.data.user);
        // Clear hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        console.error(e);
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full border-4 border-blue-500 border-t-transparent animate-spin mx-auto"/>
        <p className="mt-4 text-slate-600">Signing you in…</p>
      </div>
    </div>
  );
}
